import { useCallback, useState } from "react";
import { useAppContext } from "../../providers/ProviderAppContainer";
import { Dialog } from "primereact/dialog";
import TabHeader from "../common/TabHeader";
import { FloatLabel } from "primereact/floatlabel";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { Button } from "primereact/button";
import HasRequiredAuthority from "../dependencies/HasRequiredAuthority";
import { AUTHORITIES } from "../../constants";
import { TEXT_NORMAL } from "../../style";

export default function DialogAddBranch({ visible, setBranches, closeDialog }) {
    const { requestAPI, showToast } = useAppContext();

    const [branch, setBranch] = useState({ active: true });
    const [loading, setLoading] = useState();

    const addBranch = useCallback(() => {
        requestAPI({
            requestPath: `branches`,
            requestMethod: "POST",
            requestPostBody: {
                title: branch?.title,
                address: branch?.address,
                description: branch?.description,
                active: branch?.active !== false,
            },
            setLoading: setLoading,
            onRequestFailure: () => showToast({ severity: "error", summary: "Failed", detail: "Failed To Add Branch !", life: 2000 }),
            onResponseReceieved: (created, responseCode) => {
                if (created && responseCode === 201) {
                    showToast({ severity: "success", summary: "Added", detail: "Branch Added", life: 1000 });
                    setBranches((prev) => [...(prev || []), created]);
                    setBranch({ active: true });
                    closeDialog();
                } else {
                    showToast({ severity: "error", summary: "Failed", detail: created?.error || "Failed To Add Branch !", life: 2000 });
                }
            },
        });
    }, [branch, closeDialog, requestAPI, setBranches, showToast]);

    return (
        <Dialog pt={{ content: { className: "overflow-y-auto" } }} header="Add New Branch" visible={visible} className="w-11" onHide={closeDialog}>
            <TabHeader className="pt-3" title="Add New Branch" highlights={["Create a branch location"]} />

            <FloatLabel className="mt-5">
                <InputText
                    value={branch?.title || ""}
                    id="title"
                    className="w-full"
                    onChange={(e) => setBranch((prev) => ({ ...prev, title: e.target.value }))}
                    disabled={loading}
                    pt={{ root: { className: TEXT_NORMAL } }}
                />
                <label htmlFor="title">Title</label>
            </FloatLabel>

            <FloatLabel className="mt-5">
                <InputText
                    value={branch?.address || ""}
                    id="address"
                    className="w-full"
                    onChange={(e) => setBranch((prev) => ({ ...prev, address: e.target.value }))}
                    disabled={loading}
                    pt={{ root: { className: TEXT_NORMAL } }}
                />
                <label htmlFor="address">Address</label>
            </FloatLabel>

            <FloatLabel className="mt-5">
                <InputTextarea
                    value={branch?.description || ""}
                    id="description"
                    rows={3}
                    className="w-full"
                    onChange={(e) => setBranch((prev) => ({ ...prev, description: e.target.value }))}
                    disabled={loading}
                    pt={{ root: { className: TEXT_NORMAL } }}
                />
                <label htmlFor="description">Description</label>
            </FloatLabel>

            <HasRequiredAuthority requiredAuthority={AUTHORITIES.CREATE_BRANCH}>
                <Button
                    className="mt-3"
                    label="Add Branch"
                    severity="warning"
                    loading={loading}
                    onClick={addBranch}
                    disabled={!branch?.title?.trim() || !branch?.address?.trim() || !branch?.description?.trim()}
                />
            </HasRequiredAuthority>
        </Dialog>
    );
}
